import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { DocIdsWithCount } from '@/api/types/backend-dto-types';
import { useFetcher } from '@/api/useGetFetchConfig';

interface UseGetDocIdsOptions {
  /** Limit on the number of documents returned. */
  limit?: number;
  /** Search query to filter documents by name */
  searchQuery?: string;
  /** Keep the previous result set mounted while a new search is fetching. */
  keepPreviousData?: boolean;
}

export const useGetDocIds = (matterId: string, subsetId: string, options?: UseGetDocIdsOptions) => {
  const fetcher = useFetcher();
  const { limit, searchQuery, keepPreviousData = false } = options ?? {};

  return useQuery<DocIdsWithCount>(
    [QueryEntity.DocIds, { subsetId, limit, searchQuery }],
    () => {
      const url = new URL(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/doc-ids`);
      if (limit !== undefined) {
        url.searchParams.append('limit', limit.toString());
      }
      if (searchQuery !== undefined && searchQuery.trim() !== '') {
        url.searchParams.append('search', searchQuery.trim());
      }

      return fetcher(url.toString());
    },
    {
      enabled: !!matterId && !!subsetId,
      keepPreviousData,
    },
  );
};
